
function EmailItemEditorCtrl(TranslationService) {
    var ctrl = this;

    //console.log('email-info');

    this.close = function () {
        ctrl.errors = [];
    }

    this.getAdresses = function (addressType) {
        if (!ctrl.email) {
            return [];
        }
        if (!ctrl.email.Adresses)
        {
            return []; 
        }
        var adrs = ctrl.email.Adresses.filter(
            function (a) {
                return (a.AddressTypeName == addressType);
            }
        );       
        return adrs;
    }
}

EmailItemEditorCtrl.$inject = ['TranslationService'];

seedWebApp.component('emailInfo', {
    controller: EmailItemEditorCtrl,
    controllerAs: 'ctrl',
    bindings: {
        title: '<',
        email: '<',
    },
    templateUrl: '/SPA/logistics/email-info.html' + seedWebApp.buildVersion
});